import { ModalViewModel } from '@/infra/ModalViewModel'
import { type Job } from '@/features/jobs/Job'
import { type JobStore } from '@/features/jobs/JobStore'
import { task } from 'mobx-task'
import type { AlertErrorHandlerFactory } from '@/features/shell'
import type { NavigateFn } from '@/RootStore'
import { links } from '@/utils/link'

/**
 * View model for managing the Forfeit dialog.
 */
export class ForfeitDialogViewModel {
  readonly modal = new ModalViewModel()

  constructor(
    public readonly job: Job,
    private readonly _jobStore: JobStore,
    private readonly _navigate: NavigateFn,
    private readonly _createAlertErrorHandler: AlertErrorHandlerFactory,
  ) {}

  /**
   * Forfeits the job.
   */
  forfeit = task.resolved(async () => {
    await this._jobStore
      .forfeit(this.job)
      .catch(this._createAlertErrorHandler('Forfeiting the job failed'))
    this.modal.close()
    this._navigate(links.jobs())
  })
}
